import React from 'react';
import { Navigate } from 'react-router-dom';
import { useMerchantAuth } from '../contexts/MerchantAuthContext';

export default function MerchantProtectedRoute({ children }) {
  const { isAuthenticated, loading } = useMerchantAuth();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-[hsl(var(--brand-teal))] mx-auto"></div>
          <p className="mt-4 text-[hsl(var(--muted-foreground))]">Cargando...</p>
        </div>
      </div>
    );
  }

  return isAuthenticated ? children : <Navigate to="/portal/login" replace />;
}
